<template>
	<div>
		<flCabecalhoForm
			:msg="_traducao('global', 'obrigatorio')"
			cls="print-titulo-form-20"
			:texto="_traducao('menuAGnovoUsuario', 'menuAGacesso')"
		/>
		<div class="row form-group" v-if="possuiAcessoSistema_">
			<div class="col-xs-12">
				<label>* {{ _traducao('menuAGnovoUsuario', 'menuAGsistema') }}?</label
				><br />
				<div class="btn-group" role="group">
					<button
						type="button"
						:disabled="menu"
						@click="
							form.acesso_sistema = '1'
							$emit('getCPF')
							$forceUpdate()
						"
						class="btn btn-sm btn-default"
						:class="{ 'btn-info': form.acesso_sistema === '1' }"
					>
						{{ _traducao('menuAGnovoUsuario', 'menuAGsim') }}
					</button>
					<button
						type="button"
						:disabled="menu"
						@click="
							form.acesso_sistema = '0'
							limpaForm()
						"
						class="btn btn-sm btn-default"
						:class="{ 'btn-info': form.acesso_sistema === '0' }"
					>
						{{ _traducao('menuAGnovoUsuario', 'menuAGnao') }}
					</button>
				</div>
			</div>
		</div>
		<div v-if="form.acesso_sistema === '1'">
			<div class="row">
				<!--  LOGIN -->
				<div
					class="col-xs-12 col-md-3"
					:class="{ 'form-group': _isMobile || form.id === 0 }"
				>
					<label
						><span class="no-print">* </span
						>{{ _traducao('menuAGnovoUsuario', 'menuAGlogin') }}:</label
					>
					<input
						type="text"
						v-model="form.login"
						:disabled="!loginPor.login || !!form.id"
						class="form-control input-sm"
					/>
				</div>

				<!--  SENHA -->
				<div
					class="no-print col-xs-12 col-md-3 form-group"
					:class="{ 'has-error': erro.senha !== '', 'form-group': _isMobile }"
					v-if="!loginIAM && form.id === 0"
				>
					<label
						><span class="no-print">* </span
						>{{ _traducao('menuAGnovoUsuario', 'menuAGsenha') }}:</label
					>

					<div
						class="fa fa-eye icone-senha"
						title="Clique para ver a senha"
						@mousedown="clickSenha(true)"
						@mouseup="clickSenha(false)"
						aria-hidden="true"
					></div>
					<input
						v-show="inputSenha === 'text'"
						type="text"
						name="text"
						autocomplete="new-password"
						v-model="form.senha"
						class="form-control input-sm"
					/>
					<input
						v-show="inputSenha !== 'text'"
						type="password"
						name="password"
						autocomplete="new-password"
						v-model="form.senha"
						class="form-control input-sm"
					/>
					<p class="help-block" v-show="erro.senha !== ''">{{ erro.senha }}</p>
				</div>
				<div
					class="no-print col-xs-12 col-md-3 form-group"
					v-if="!loginIAM && form.id !== 0"
					:class="{ 'form-group': _isMobile }"
				>
					<label style="visibility: hidden;"> Senha </label><br />
					<button
						class="btn btn-block btn-default btn-sm"
						@click="exibeModalAlteraSenha()"
					>
						<i class="fa fa-fw fa-lock"></i>
						{{ _traducao('global', 'alterarSenha').toUpperCase() }}
					</button>
					<!-- v-show="menu === true || form.id !== 0" -->
				</div>

				<!--  ASSINATURA -->
				<div>
					<div
						class="no-print col-xs-12 col-md-3 form-group"
						v-if="form.id === 0"
						:class="{
							'has-error': erro.assinatura !== '',
							'form-group': _isMobile,
						}"
					>
						<label>{{ _traducao('global', 'assinaturaDigital') }}:</label>

						<div
							class="fa fa-eye icone-senha"
							title="Clique para ver a senha"
							@mousedown="clickAssinatura(true)"
							@mouseup="clickAssinatura(false)"
							aria-hidden="true"
						></div>
						<input
							v-show="inputAssinatura === 'text'"
							name="text"
							autocomplete="off"
							type="text"
							v-mask="'00000000'"
							v-model="form.assinatura"
							class="form-control input-sm"
						/>
						<input
							v-show="inputAssinatura !== 'text'"
							name="assinatura"
							autocomplete="off"
							type="password"
							v-model="form.assinatura"
							class="form-control input-sm"
						/>
						<p class="help-block" v-show="erro.assinatura !== ''">
							{{ erro.assinatura }}
						</p>
						<!-- v-show="menu === true || form.id !== 0" -->
					</div>

					<div
						class="no-print col-xs-12 col-md-3 form-group"
						v-if="form.id !== 0"
						:class="{ 'form-group': _isMobile }"
					>
						<label style="visibility: hidden;">Assinatura</label>
						<button
							class="btn btn-block btn-default btn-sm"
							@click="exibeModalAlteraAssinatura()"
						>
							<i class="fa fa-fw fa-lock"></i>
							{{ _traducao('global', 'alterarAssinatura').toUpperCase() }}
						</button>
					</div>
				</div>
			</div>
			<!-- Perfil -->
			<div class="row">
				<div
					v-if="!menu"
					class="col-md-3 col-xs-12 no-print form-group"
					:class="{ 'has-error': erro.id_perfil !== '' }"
				>
					<label>* {{ _traducao('global', 'perfis') }}:</label>
					<div class="input-group">
						<select class="form-control input-sm" v-model="form.id_perfil">
							<option value="">{{
								_traducao('global', 'escolha').toUpperCase()
							}}</option>
							<option
								v-for="item in perfis"
								:value="item"
								:key="item.descricao"
								>{{ item.descricao }}</option
							>
						</select>
						<span class="input-group-btn">
							<button
								class="btn btn-sm btn-info"
								@click="clickAddPerfil()"
								type="button"
							>
								ADD<i class="fa fa-arrow-right fa-fw"></i>
							</button>
						</span>
					</div>
					<p class="help-block" v-show="erro.id_perfil !== ''">
						{{ erro.id_perfil }}
					</p>
				</div>

				<div class="col-xs-12 col-md-9" :class="{ 'form-group': _isMobile }">
					<label style="margin-bottom: 6px;"
						>* {{ _traducao('global', 'perfilDoUsuario') }}:</label
					>
					<br />
					<span
						v-for="(it, idx) in form.perfis"
						:key="idx"
						style="margin-top: 3px;"
					>
						<span
							title="Clique para remover"
							@click="!menu ? form.perfis.splice(idx, 1) : ''"
							class="label-click"
							:style="{ cursor: !menu ? 'pointer' : 'default' }"
						>
							{{ it.descricao }}
							<i class="fa fa-times no-print" v-if="!menu"></i>
						</span>
					</span>
				</div>
			</div>
			<div class="row">
				<div v-show="menu === false && form.desenvolvedor">
					<div class="no-print col-xs-12 col-md-3 form-group">
						<label style="margin-bottom: 5px;"
							>{{ _traducao('global', 'hAssinatura') }} ICP?</label
						><br />
						<div class="btn-group print-button-group" role="group">
							<button
								type="button"
								@click="form.certificado_icp = '1'"
								:class="{ 'btn-info': form.certificado_icp === '1' }"
								class="btn btn-default btn-sm"
							>
								{{ _traducao('global', 'sim') }}
							</button>
							<button
								type="button"
								@click="form.certificado_icp = '0'"
								:class="{ 'btn-info': form.certificado_icp === '0' }"
								class="btn btn-default btn-sm"
							>
								{{ _traducao('global', 'nao') }}
							</button>
						</div>
					</div>

					<transition enterActiveClass="animated fadeIn">
						<div
							v-if="form.certificado_icp === '1'"
							class="no-print col-xs-12 col-md-3"
							:class="{ 'has-error': erro.senha_icp !== '' }"
						>
							<label
								><span class="no-print">* </span
								>{{ _traducao('menuAGnovoUsuario', 'menuAGsenha') }} ICP:</label
							>

							<div
								class="fa fa-eye icone-senha"
								title="Clique para ver a senha"
								@mousedown="clickSenhaICP(true)"
								@mouseup="clickSenhaICP(false)"
								aria-hidden="true"
							></div>
							<input
								v-show="inputSenhaICP === 'text'"
								type="text"
								v-model="form.senha_icp"
								class="form-control input-sm"
							/>
							<input
								v-show="inputSenhaICP !== 'text'"
								type="password"
								v-model="form.senha_icp"
								class="form-control input-sm"
							/>
							<p class="help-block" v-show="erro.senha_icp !== ''">
								{{ erro.senha_icp }}
							</p>
							<small class="text-info" v-show="menu === true || form.id !== 0">
								<i class="fa fa-info-circle"></i>
								{{ _traducao('menuAGnovoUsuario', 'menuAGbranco') }}
							</small>
						</div>
					</transition>
				</div>

				<div class="col-md-3 col-xs-12 form-group" v-if="form.id === 0">
					<label style="margin-bottom: 6px;">{{
						_traducao('global', 'alterarSenhaProximoLogin')
					}}</label
					><br />
					<div class="btn-group print-button-group" role="group">
						<button
							type="button"
							@click="form.atualiza_senha = '1'"
							:class="{ 'btn-info': form.atualiza_senha === '1' }"
							class="btn btn-default btn-sm"
						>
							{{ _traducao('global', 'sim') }}
						</button>
						<button
							type="button"
							@click="form.atualiza_senha = '0'"
							:class="{ 'btn-info': form.atualiza_senha === '0' }"
							class="btn btn-default btn-sm"
						>
							{{ _traducao('global', 'nao') }}
						</button>
					</div>
				</div>

				<div class="col-md-3 col-xs-12 form-group" v-if="form.id === 0">
					<label style="margin-bottom: 6px;">{{
						_traducao('global', 'alterarAssinaturaNoProximoLogin')
					}}</label
					><br />
					<div class="btn-group print-button-group" role="group">
						<button
							type="button"
							@click="form.atualiza_assinatura = '1'"
							:class="{ 'btn-info': form.atualiza_assinatura === '1' }"
							class="btn btn-default btn-sm"
						>
							{{ _traducao('global', 'sim') }}
						</button>
						<button
							type="button"
							@click="form.atualiza_assinatura = '0'"
							:class="{ 'btn-info': form.atualiza_assinatura === '0' }"
							class="btn btn-default btn-sm"
						>
							{{ _traducao('global', 'nao') }}
						</button>
					</div>
				</div>
			</div>
			<div v-if="exibeModalSenha">
				<flModalAlterarSenha
					:token="token"
					ref="alterarSenhaAss"
					@fecha-modal="
						() => {
							exibeModalSenha = false
						}
					"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import flModalAlterarSenha from './modal/modal-alterar-senha.vue'
import tiposLoginUsuarioMixin from '../mixins/tiposLoginUsuario.mixin'
export default {
	components: {
		flModalAlterarSenha,
	},

	mixins: [tiposLoginUsuarioMixin],

	props: {
		menu: {
			type: Boolean,
		},

		perfis: {
			type: Array,
		},

		token: {
			type: String,
			require: false,
		},
	},

	data() {
		return {
			acesso: window.$cliente.get('id') === '5' ? false : true,
			inputSenha: '',
			inputAssinatura: '',
			inputSenhaICP: '',

			itemForm: '',

			form: {
				id: 0,
				login: '',
				senha: '',
				certificado_icp: '',
				senha_icp: '',
				id_perfil: '',
				perfis: [],
				atualiza_senha: '0',
				atualiza_assinatura: '0',
				desenvolvedor: '',
				acesso_sistema: '1',
			},

			erro: {
				senha: '',
				assinatura: '',
				certificado_icp: '',
				senha_icp: '',
				id_perfil: '',
			},

			exibeModalSenha: false,
		}
	},

	computed: {
		possuiAcessoSistema_() {
			if (
				window.$cliente.get('id') === 9 ||
				window.$cliente.get('id') === 10 ||
				window.$cliente.get('id') === 18
			) {
				return false
			} else {
				return true
			}
		},

		loginIAM() {
			return window.$cliente.get('login_iam') === '1'
		},
	},

	mounted() {
		this.form.desenvolvedor = window.$sessao.getDev()
	},

	methods: {
		editar(form) {
			this.itemForm = form
			;(this.form.id = form.id), (this.form.login = form.login)
			this.form.certificado_icp = form.certificado_icp
			this.form.perfis = form.perfis
			;(this.form.atualiza_senha = form.atualiza_senha),
			(this.form.atualiza_assinatura = form.atualiza_assinatura)
			this.form.id_perfil = form.id_perfil
			this.form.acesso_sistema = form.acesso_sistema
		},

		clickAddPerfil() {
			if (this.form.id_perfil !== '') {
				var jaAdd = false

				for (var i in this.form.perfis) {
					if (this.form.perfis[i].id === this.form.id_perfil.id) {
						window.bus.$emit('exibir-notificacao', {
							text: this._traducao('global', 'voceJaAddEssePerfil'),
							type: 'danger',
						})
						jaAdd = true
						break
					}
				}

				if (!jaAdd) {
					this.form.perfis.push(this.form.id_perfil)
				}
			}
		},

		exibeModalAlteraSenha() {
			this.exibeModalSenha = true
			let controleSenha = true
			this.$nextTick(() => {
				this.$refs.alterarSenhaAss.carregaModal(controleSenha, this.form.id)
			})
		},

		exibeModalAlteraAssinatura() {
			this.exibeModalSenha = true
			let controleSenha = false
			this.$nextTick(() => {
				this.$refs.alterarSenhaAss.carregaModal(controleSenha, this.form.id)
			})
		},

		clickSenha(item) {
			if (item) {
				this.inputSenha = 'text'
			} else {
				this.inputSenha = ''
			}
		},

		clickAssinatura(item) {
			if (item) {
				this.inputAssinatura = 'text'
			} else {
				this.inputAssinatura = ''
			}
		},

		clickSenhaICP(item) {
			if (item) {
				this.inputSenhaICP = 'text'
			} else {
				this.inputSenhaICP = ''
			}
		},

		validaForm() {
			let passou = true
			let obg = this._traducao('global', 'campoObrigatorio')

			if (this.form.acesso_sistema === '1') {
				if (this.form.id === 0) {
					if (this.form.senha === '') {
						this.erro.senha = obg
						passou = false
					} else {
						this.erro.senha = ''
					}

					if (this.form.certificado_icp === '1') {
						if (this.form.senha_icp === '' && this.form.id === 0) {
							this.erro.senha_icp = obg
							passou = false
						} else {
							this.erro.senha_icp = ''
						}
					}
				}

				if (this.form.perfis.length === 0) {
					this.erro.id_perfil = obg
					passou = false
				} else {
					this.erro.id_perfil = ''
				}
			}

			if (passou) {
				this.$emit('dados-acesso-sistema', this.form)
			}

			return passou
		},

		limpaForm() {
			this.form.login = ''
			this.form.senha = ''
			this.form.certificado_icp = ''
			this.form.senha_icp = ''
			this.form.id_perfil = ''
			this.form.perfis = []
			this.form.atualiza_senha = '0'
			this.form.atualiza_assinatura = '0'
			this.form.desenvolvedor = ''
			this.form.acesso_sistema = '0'

			this.erro.senha = ''
			this.erro.assinatura = ''
			this.erro.certificado_icp = ''
			this.erro.senha_icp = ''
			this.erro.id_perfil = ''
		},

		setaLoginSenha(cpf) {
			if (window.$cliente.get('login') === 'cpf') {
				this.form.login = cpf
				this.form.senha = cpf
				this.$forceUpdate()
			}
		},
	},
}
</script>
